@if (asset) {
	<div>
		<div class="section-title">{{asset.asset_name}} ({{asset.obcu_serial_number}})</div>
		<div class="mb-3">
			<a [href]="'/dash/fleet/' + asset.fleet_id + '/asset/' + asset.asset_id">Open in Foresight <i class="icon-link-ext"></i></a>
		</div>
		<div class="bubble-tabs mt-0">
			<a class="bubble-tab" routerLink="asset-general" routerLinkActive="selected">General</a>
			<a class="bubble-tab" routerLink="asset-notes" routerLinkActive="selected">Notes</a>
			<a class="bubble-tab" routerLink="asset-files" routerLinkActive="selected">Files</a>
			<a class="bubble-tab" routerLink="asset-data" routerLinkActive="selected">Data</a>
			@if (!asset.is_fixed) {
				<a class="bubble-tab" routerLink="asset-firmware" routerLinkActive="selected">Firmware</a>
			}
			<a class="bubble-tab" routerLink="asset-partner" routerLinkActive="selected">Partner organizations</a>
			<a class="bubble-tab" routerLink="asset-destructive" routerLinkActive="selected">Destructive ops</a>
		</div>
		<router-outlet (activate)="updateRouterOutlet($event)"></router-outlet>
	</div>
}